import Service from '@/common/service.js';

import { User } from './partials/user.js';
import { Organisation } from './partials/organisation.js';
import { Job } from './partials/job.js';
import { Alert } from './partials/alert.js';
import { Newsletter } from './partials/newsletter.js';

class Api {
	constructor() {
		this.service = new Service('');
	}
}

Object.assign(Api.prototype, User);
Object.assign(Api.prototype, Organisation);
Object.assign(Api.prototype, Job);
Object.assign(Api.prototype, Alert);
Object.assign(Api.prototype, Newsletter);

export default new Api;
